import { render, staticRenderFns } from "./Join.vue?vue&type=template&id=b1d9c3d4&scoped=true&"
import script from "./Join.vue?vue&type=script&lang=js&"
export * from "./Join.vue?vue&type=script&lang=js&"
import style0 from "./Join.vue?vue&type=style&index=0&lang=css&"
import style1 from "./Join.vue?vue&type=style&index=1&id=b1d9c3d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d9c3d4",
  null
  
)

export default component.exports